import React from 'react';
import Footer from './Footer';
import './ImportantView/CRV.css';
import { useEffect } from 'react';

function Contact () {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <div>
                <section>
                    <div className='holds-the-iframe'>
                    <iframe className='frame' src="https://quicklearn-contact.onrender.com/" height={'600px'}></iframe>   
                    </div>
                <div class='air air1'></div>
                <div class='air air2'></div>
                <div class='air air3'></div>
                <div class='air air4'></div>
            </section>
            <Footer/>
        </div>
    );
}

export default Contact;
